import { DifferenceTypeNames, FormattingDifferences, SpellingDifferences } from 'types';
import { ColorId, colorIdToHex } from '@verify/shared-utils';

export const DEFAULT_DIFFERENCE_COLOR = colorIdToHex[ColorId.RED];
const FORMATTING_COLOR = colorIdToHex[ColorId.PINK];
const SPELLING_COLOR = colorIdToHex[ColorId.YELLOW];

export const DifferenceTypesWithHighlightColor = [
  FormattingDifferences.Bold,
  FormattingDifferences.Italic,
  FormattingDifferences.Underlined,
  FormattingDifferences.Subscript,
  FormattingDifferences.Superscript,
  FormattingDifferences.FontType,
  FormattingDifferences.FontColor,
  FormattingDifferences.Size,
  FormattingDifferences.FontSize,
  FormattingDifferences.SoftHyphen,
  FormattingDifferences.LineBreakSpace,
  SpellingDifferences.SpellingGeneral,
  SpellingDifferences.Abbreviation,
  SpellingDifferences.ProperNoun,
  SpellingDifferences.Alphanumeric,
  DifferenceTypeNames.Insertion,
  DifferenceTypeNames.ReadingOrder,
  DifferenceTypeNames.Case,
  DifferenceTypeNames.Space,
  DifferenceTypeNames.Deletion,
  DifferenceTypeNames.Change,
  DifferenceTypeNames.Hyphen,
];

export const differenceHighlightColors: Record<string, string> = {
  // Formatting Group
  [FormattingDifferences.Bold]: FORMATTING_COLOR,
  [FormattingDifferences.Italic]: FORMATTING_COLOR,
  [FormattingDifferences.Underlined]: FORMATTING_COLOR,
  [FormattingDifferences.Subscript]: FORMATTING_COLOR,
  [FormattingDifferences.Superscript]: FORMATTING_COLOR,
  [FormattingDifferences.FontType]: FORMATTING_COLOR,
  [FormattingDifferences.FontColor]: FORMATTING_COLOR,
  [FormattingDifferences.Size]: FORMATTING_COLOR,
  [FormattingDifferences.FontSize]: FORMATTING_COLOR,
  [FormattingDifferences.SoftHyphen]: FORMATTING_COLOR,
  [FormattingDifferences.LineBreakSpace]: FORMATTING_COLOR,

  // Spelling Group
  [SpellingDifferences.SpellingGeneral]: SPELLING_COLOR,
  [SpellingDifferences.Abbreviation]: SPELLING_COLOR,
  [SpellingDifferences.ProperNoun]: SPELLING_COLOR,
  [SpellingDifferences.Alphanumeric]: SPELLING_COLOR,

  // Individual Types
  [DifferenceTypeNames.Insertion]: colorIdToHex[ColorId.GREEN],
  [DifferenceTypeNames.ReadingOrder]: colorIdToHex[ColorId.BLUE],
  [DifferenceTypeNames.Case]: colorIdToHex[ColorId.INDIGO],
  [DifferenceTypeNames.Space]: colorIdToHex[ColorId.PURPLE],
  [DifferenceTypeNames.Deletion]: colorIdToHex[ColorId.RED],
  [DifferenceTypeNames.Change]: colorIdToHex[ColorId.ORANGE],
  [DifferenceTypeNames.Hyphen]: colorIdToHex[ColorId.ORANGE],
  [DifferenceTypeNames.Markup]: colorIdToHex[ColorId.RED],
};

export interface ColorOption {
  id: ColorId;
  name: string;
  hex: string;
}

// Export a structured array of color options for UI components
export const colorOptions: ColorOption[] = [
  { id: ColorId.MULTICOLOR, name: 'Multi-color', hex: 'multicolor' },
  { id: ColorId.GREEN, name: 'Green', hex: colorIdToHex[ColorId.GREEN] }, // Insertion color
  { id: ColorId.RED, name: 'Red', hex: colorIdToHex[ColorId.RED] },
  { id: ColorId.ORANGE, name: 'Orange', hex: colorIdToHex[ColorId.ORANGE] }, // Change color
  { id: ColorId.INDIGO, name: 'Indigo', hex: colorIdToHex[ColorId.INDIGO] }, // Case color
  { id: ColorId.PURPLE, name: 'Purple', hex: colorIdToHex[ColorId.PURPLE] }, // Space color
  { id: ColorId.BLUE, name: 'Blue', hex: colorIdToHex[ColorId.BLUE] }, // Reading Order color
  { id: ColorId.CYAN, name: 'Cyan', hex: colorIdToHex[ColorId.CYAN] },
  { id: ColorId.SLATE, name: 'Slate', hex: colorIdToHex[ColorId.SLATE] },
  { id: ColorId.PINK, name: 'Pink', hex: colorIdToHex[ColorId.PINK] },
  { id: ColorId.YELLOW, name: 'Yellow', hex: colorIdToHex[ColorId.YELLOW] },
];
